// ABOUTME: The placeholder drawn while the applications list loads: two card-shaped blocks where the cards will be.
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const ApplicationsSkeleton = () => (
  <Box data-testid="applications-skeleton">
    <Skeleton variant="rounded" height={220} sx={{ borderRadius: 4, mb: 2 }} />
    <Skeleton variant="rounded" height={220} sx={{ borderRadius: 4 }} />
  </Box>
);
